/**
 * Streamlined Quiz Results Page - Optimal Structure for 100M ARR
 * Hero with product image, rating, key benefits, subtle upgrade banner
 */

(function() {
  'use strict';

  // These will be populated when VelunaQuizResultsOptimal loads
  let VERIFIED_PRICING = {};
  let CATEGORY_NAMES = {};
  let BUNDLE_NAMES = {};
  let PRODUCT_IMAGES = {};
  let generateAnswerBasedNarrative = function() { return {}; };
  
  function loadOptimalData() {
    if (window.VelunaQuizResultsOptimal) {
      VERIFIED_PRICING = window.VelunaQuizResultsOptimal.VERIFIED_PRICING || {};
      CATEGORY_NAMES = window.VelunaQuizResultsOptimal.CATEGORY_NAMES || {};
      BUNDLE_NAMES = window.VelunaQuizResultsOptimal.BUNDLE_NAMES || {};
      PRODUCT_IMAGES = window.VelunaQuizResultsOptimal.PRODUCT_IMAGES || {};
      generateAnswerBasedNarrative = window.VelunaQuizResultsOptimal.generateAnswerBasedNarrative || function() { return {}; };
      return true;
    }
    return false;
  }

  /**
   * Generate key benefits (3-4 bullet points based on category)
   */
  function generateKeyBenefits(category, bundleType) {
    const benefits = {
      'mind-calm': {
        'starter-set': [
          'Reduces cortisol and stress levels throughout the day',
          'Calms nervous system for deeper sleep',
          'Addresses racing mind and anxiety'
        ],
        'full-set': [
          'Complete stress and sleep optimization',
          '4-product protocol for maximum results',
          'Addresses both daytime stress and nighttime sleep'
        ]
      },
      'deep-restore': {
        'starter-set': [
          'Promotes muscle relaxation and recovery',
          'Supports deep, restorative sleep',
          'Reduces muscle tension and soreness'
        ],
        'full-set': [
          'Complete recovery and sleep protocol',
          '4-product system for optimal restoration',
          'Addresses muscle recovery and sleep quality'
        ]
      },
      'circadian-reset': {
        'starter-set': [
          'Helps regulate sleep-wake cycle',
          'Supports natural circadian rhythm',
          'Improves sleep timing and quality'
        ],
        'full-set': [
          'Complete circadian optimization',
          '4-product protocol for rhythm reset',
          'Addresses timing and sleep quality'
        ]
      },
      'sacred-soothe': {
        'starter-set': [
          'Nourishes and hydrates skin overnight',
          'Promotes relaxation and calm',
          'Supports skin health and sleep'
        ],
        'full-set': [
          'Complete skin and sleep protocol',
          '4-product system for optimal results',
          'Addresses both skin health and sleep quality'
        ]
      }
    };

    return benefits[category]?.[bundleType] || [
      'Personalized for your sleep needs',
      'Science-backed ingredients',
      'Free shipping included'
    ];
  }

  /**
   * Generate hero section with product image, rating, and trust badges
   */
  function generateHero(category, bundleType, pricing, narrative) {
    const categoryName = CATEGORY_NAMES[category] || category;
    const bundleName = BUNDLE_NAMES[bundleType] || bundleType;
    
    // Get first product image for hero
    const firstProduct = pricing.products[0] || '';
    const heroImageHandle = PRODUCT_IMAGES[firstProduct] || '';
    const heroImageUrl = heroImageHandle ? `${heroImageHandle}.jpg` : '';

    // Generate social proof number (simulated - would come from analytics)
    const socialProofCount = Math.floor(Math.random() * 50) + 10; // 10-60 people

    return `
      <div class="veluna-quiz-results-streamlined__hero">
        <div class="veluna-quiz-results-streamlined__hero-content">
          <p class="veluna-quiz-results-streamlined__eyebrow">Personalized for You</p>
          <h1 class="veluna-quiz-results-streamlined__title">Your Perfect Sleep Ritual</h1>
          <p class="veluna-quiz-results-streamlined__subtitle">Based on your answers, we've curated this ritual for you</p>
          
          ${heroImageUrl ? `
            <div class="veluna-quiz-results-streamlined__hero-image">
              <img src="${heroImageUrl}" alt="${categoryName} ${bundleName}" loading="eager" class="veluna-quiz-results-streamlined__product-image-large">
            </div>
          ` : ''}
          
          <div class="veluna-quiz-results-streamlined__rating">
            <span class="veluna-quiz-results-streamlined__stars">★★★★★</span>
            <span class="veluna-quiz-results-streamlined__rating-text">4.8/5</span>
            <span class="veluna-quiz-results-streamlined__rating-count">(1,234+ reviews)</span>
          </div>
          
          <div class="veluna-quiz-results-streamlined__social-proof-number">
            <span class="veluna-quiz-results-streamlined__social-proof-icon">👥</span>
            <span class="veluna-quiz-results-streamlined__social-proof-text">${socialProofCount} people bought this today</span>
          </div>
          
          <div class="veluna-quiz-results-streamlined__trust-badges">
            <div class="veluna-quiz-results-streamlined__trust-badge">
              <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" class="veluna-quiz-results-streamlined__trust-icon">
                <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              <span>30-Night Guarantee</span>
            </div>
            <div class="veluna-quiz-results-streamlined__trust-badge">
              <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" class="veluna-quiz-results-streamlined__trust-icon">
                <path d="M5 13l4 4L19 7m-1 4v6a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h6m4 0h6v6m-11 5l2.5-2.5L15 16l-2.5 2.5L10 16z"/>
              </svg>
              <span>Science-Backed</span>
            </div>
            <div class="veluna-quiz-results-streamlined__trust-badge">
              <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" class="veluna-quiz-results-streamlined__trust-icon">
                <path d="M8 7V3m4 4V3m-9 8h10M5 21h10a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
              </svg>
              <span>FDA-Registered Facilities</span>
            </div>
            <div class="veluna-quiz-results-streamlined__trust-badge">
              <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" class="veluna-quiz-results-streamlined__trust-icon">
                <path d="M5 8h10M5 8a2 2 0 110-4h10a2 2 0 110 4M5 8v10a2 2 0 002 2h6a2 2 0 002-2V8m-9 4h10"/>
              </svg>
              <span>Free Shipping</span>
            </div>
          </div>
          
          <div class="veluna-quiz-results-streamlined__recommended-card">
            <div class="veluna-quiz-results-streamlined__badge">Recommended for You</div>
            <h2 class="veluna-quiz-results-streamlined__set-title">${categoryName} ${bundleName}</h2>
            <p class="veluna-quiz-results-streamlined__set-description">${narrative.opening}</p>
            
            <div class="veluna-quiz-results-streamlined__pricing-hero">
              <span class="veluna-quiz-results-streamlined__price-regular">$${pricing.regularPrice}</span>
              <span class="veluna-quiz-results-streamlined__price-discounted">$${pricing.discountedPrice}</span>
              <span class="veluna-quiz-results-streamlined__price-save">Save $${pricing.regularPrice - pricing.discountedPrice}</span>
            </div>
            
            <button class="veluna-btn veluna-btn-primary veluna-quiz-results-streamlined__cta-primary" 
                    data-results-add-to-cart 
                    data-category="${category}" 
                    data-bundle="${bundleType}"
                    aria-label="Add ${categoryName} ${bundleName} to cart for $${pricing.discountedPrice}">
              Add to Cart - $${pricing.discountedPrice}
            </button>
            
            <div class="veluna-quiz-results-streamlined__luna-cta">
              <button class="veluna-quiz-results-streamlined__luna-btn" onclick="window.Luna?.openChatbot(); return false;" aria-label="Chat with Luna">
                <span class="veluna-quiz-results-streamlined__luna-icon">💬</span>
                <span>Need help? Chat with Luna</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  /**
   * Generate key benefits section
   */
  function generateKeyBenefitsSection(category, bundleType) {
    const benefits = generateKeyBenefits(category, bundleType);
    
    return `
      <div class="veluna-quiz-results-streamlined__benefits">
        <h3 class="veluna-quiz-results-streamlined__benefits-title">Key Benefits</h3>
        <ul class="veluna-quiz-results-streamlined__benefits-list">
          ${benefits.map(benefit => `
            <li class="veluna-quiz-results-streamlined__benefit-item">
              <span class="veluna-quiz-results-streamlined__benefit-check">✓</span>
              <span class="veluna-quiz-results-streamlined__benefit-text">${benefit}</span>
            </li>
          `).join('')}
        </ul>
      </div>
    `;
  }

  /**
   * Generate subtle upgrade banner (not full section)
   */
  function generateUpgradeBanner(category, bundleType, pricing, fullSetPricing, narrative) {
    if (bundleType === 'full-set') return '';
    
    const categoryName = CATEGORY_NAMES[category] || category;
    const upgradeSavings = fullSetPricing.discountedPrice - pricing.discountedPrice;
    
    return `
      <div class="veluna-quiz-results-streamlined__upgrade-banner" data-upgrade-banner>
        <div class="veluna-quiz-results-streamlined__upgrade-banner-content">
          <div class="veluna-quiz-results-streamlined__upgrade-banner-text">
            <strong>Want Maximum Results?</strong>
            <span>Upgrade to ${categoryName} Full Set and save $${upgradeSavings} more</span>
          </div>
          <div class="veluna-quiz-results-streamlined__upgrade-banner-actions">
            <button class="veluna-btn veluna-btn-secondary veluna-quiz-results-streamlined__upgrade-btn" 
                    data-upgrade-toggle
                    aria-label="Compare sets">
              Compare Sets
            </button>
            <button class="veluna-btn veluna-btn-primary veluna-quiz-results-streamlined__upgrade-cta" 
                    data-results-add-to-cart 
                    data-category="${category}" 
                    data-bundle="full-set"
                    aria-label="Upgrade to Full Set">
              Upgrade to Full Set - $${fullSetPricing.discountedPrice}
            </button>
          </div>
        </div>
        
        <div class="veluna-quiz-results-streamlined__comparison-table" data-comparison-table style="display: none;">
          <h4 class="veluna-quiz-results-streamlined__comparison-title">Starter Set vs. Full Set Comparison</h4>
          <table class="veluna-quiz-results-streamlined__comparison">
            <thead>
              <tr>
                <th>Feature</th>
                <th>Starter Set</th>
                <th>Full Set</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Products Included</td>
                <td>${pricing.productCount} products</td>
                <td>${fullSetPricing.productCount} products</td>
              </tr>
              <tr>
                <td>Price</td>
                <td>$${pricing.discountedPrice}</td>
                <td>$${fullSetPricing.discountedPrice}</td>
              </tr>
              <tr>
                <td>Additional Products</td>
                <td>-</td>
                <td>+${fullSetPricing.productCount - pricing.productCount} more products</td>
              </tr>
              <tr>
                <td>Total Savings</td>
                <td>$${pricing.savings.toFixed(2)}</td>
                <td>$${fullSetPricing.savings.toFixed(2)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    `;
  }

  /**
   * Generate streamlined testimonials (2 instead of 3)
   */
  function generateTestimonials(category) {
    const testimonials = {
      // Placeholder testimonials removed 2026-09-10: no verifiable purchasers (internal compliance review).
    };

    const categoryTestimonials = testimonials[category] || testimonials['mind-calm'];

    return `
      <div class="veluna-quiz-results-streamlined__testimonials">
        <h3 class="veluna-quiz-results-streamlined__testimonials-title">What Customers Are Saying</h3>
        <div class="veluna-quiz-results-streamlined__testimonials-grid">
          ${categoryTestimonials.slice(0, 2).map(testimonial => `
            <div class="veluna-quiz-results-streamlined__testimonial-card">
              <div class="veluna-quiz-results-streamlined__testimonial-rating">★★★★★</div>
              <p class="veluna-quiz-results-streamlined__testimonial-quote">"${testimonial.quote}"</p>
              <div class="veluna-quiz-results-streamlined__testimonial-author">
                <strong>${testimonial.author}</strong>
                <span>${testimonial.location}</span>
              </div>
              <div class="veluna-quiz-results-streamlined__testimonial-verified">✓ Verified Purchase</div>
            </div>
          `).join('')}
        </div>
      </div>
    `;
  }

  /**
   * Main render function - Streamlined structure
   */
  function renderStreamlinedResults() {
    const urlParams = new URLSearchParams(window.location.search);
    const category = urlParams.get('category');
    const bundleType = urlParams.get('bundle');

    if (!category || !bundleType) {
      console.error('Missing category or bundle parameters');
      return;
    }

    const pricing = VERIFIED_PRICING[category]?.[bundleType];
    const fullSetPricing = VERIFIED_PRICING[category]?.['full-set'];

    if (!pricing || !fullSetPricing) {
      console.error('Pricing not found for', category, bundleType);
      return;
    }

    // Get quiz answers from session storage
    const quizResults = sessionStorage.getItem('veluna_quiz_results');
    let answers = {};
    if (quizResults) {
      try {
        const parsed = JSON.parse(quizResults);
        answers = parsed.answers || {};
      } catch (e) {
        console.warn('Failed to parse quiz results:', e);
      }
    }

    const narrative = generateAnswerBasedNarrative(category, bundleType, answers);

    // Build HTML in optimal order
    let html = `
      <div class="veluna-quiz-results-streamlined" data-quiz-results-streamlined>
        ${generateHero(category, bundleType, pricing, narrative)}
        ${generateKeyBenefitsSection(category, bundleType)}
        ${generateTestimonials(category)}
        ${generateUpgradeBanner(category, bundleType, pricing, fullSetPricing, narrative)}
      </div>
    `;

    // Insert into container
    const container = document.querySelector('[data-quiz-results-container]');
    if (container) {
      container.innerHTML = html;
      
      // Initialize comparison toggle
      const upgradeToggle = container.querySelector('[data-upgrade-toggle]');
      const comparisonTable = container.querySelector('[data-comparison-table]');
      
      if (upgradeToggle && comparisonTable) {
        upgradeToggle.addEventListener('click', function() {
          const isVisible = comparisonTable.style.display !== 'none';
          comparisonTable.style.display = isVisible ? 'none' : 'block';
          this.textContent = isVisible ? 'Compare Sets' : 'Hide Comparison';
          this.setAttribute('aria-expanded', !isVisible);
        });
      }
      
      console.log('Streamlined quiz results rendered');
    }
  }

  /**
   * Initialize
   */
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }

    // Wait for VelunaQuizResultsOptimal to load
    function waitForOptimal() {
      if (loadOptimalData()) {
        renderStreamlinedResults();
      } else {
        setTimeout(waitForOptimal, 100);
      }
    }

    waitForOptimal();
  }

  init();

  // Export
  if (typeof window !== 'undefined') {
    window.VelunaQuizResultsStreamlined = {
      renderStreamlinedResults,
      generateHero,
      generateKeyBenefitsSection,
      generateUpgradeBanner,
      generateTestimonials
    };
  }
})();

